import React from 'react';
import styled from 'styled-components';

interface TimeSlotsProps {
  slots: string[];
  value?: string;
  onChange?: (val: string) => void;
}

const TimeSlots: React.FC<TimeSlotsProps> = ({ slots, value, onChange }) => {
  return (
    <TimeGridWrap>
      <TimeGrid>
        {slots.map((slot) => (
          <TimeSlot
            key={slot}
          $selected={slot === value}
          onClick={() => onChange?.(slot)}
        >
          {slot}
        </TimeSlot>
      ))}
    </TimeGrid>
  </TimeGridWrap>
  );
};

export default TimeSlots;

const TimeGridWrap = styled.div`
  margin-top: 8px;
`;

const TimeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
`;

const TimeSlot = styled.div<{ $selected: boolean }>`
  padding: 5px 2px;
  text-align: center;
  font-size: 14px;
  color: ${({ $selected }) => ($selected ? '#fff' : '#555')};
  background: ${({ $selected }) => ($selected ? '#1a1a1a' : 'transparent')};
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${({ $selected }) => ($selected ? '#1a1a1a' : 'transparent')};
  transition: all 0.15s;
  &:hover {
    background: ${({ $selected }) => ($selected ? '#1a1a1a' : '#e6f4ff')};
    border-color: ${({ $selected }) => ($selected ? '#1a1a1a' : '#91caff')};
    color: ${({ $selected }) => ($selected ? '#fff' : '#1677ff')};
  }
`;
